module.exports = __webpack_public_path__ + "static/media/225-maldives.910ac8a0.svg";